<template lang="pug">
.content.front.in-page
    Breadcrumb(:lstBreadcrumb="lstBreadcrumb")
    .box-page
        .container
            .col-md-12.col-sm-12.box-content
                | {{$t("home.comming_soon")}}
        .clearfix
</template>
<script>
// import gql from 'graphql-tag'
// import graphql from '../../../Model/graphqlfront'
import Breadcrumb from '../Breadcrumb'
export default {
  components: {
    Breadcrumb
  },
  data() {
    return {
      lstBreadcrumb: []
    }
  },
  methods: {
    onBreadcrumb() {
      let lstPages = [
        {'name': '', 'title': this.$t('footer.terms_of_use')}
      ]
      this.lstBreadcrumb.push(lstPages)
    }
  },
  created() {
    this.$store.commit('setIsHomePage', true)
    this.onBreadcrumb()
  },
  apollo: {
  }
}
</script>
<style lang="scss">
.content.front.in-page{background: #FAFAFA;
    .box-page{margin-top:0; padding-bottom: 20px;
    }
}
@media (max-width: 1366px){
}
@media (max-width: 1024px){
}
@media (max-width: 991px){
}
@media (max-width: 768px){
}

@media (max-width: 375px){
}
</style>




// WEBPACK FOOTER //
// terms_of_use.vue?d6bfd716